// TODO: move `access_token=${token}` to separate function
import axiosService from '@services/axiosService';
import VALIDATION_ERROR_MESSAGES from '@config/validation-messages-constants';
import {
  checkErrors,
  isValidPhoneNumber,
  isValidEmail,
} from '@services/validationService';

export const updateOrganization = ({
  token,
  name,
  company,
  country,
  lang,
  isActive,
  id,
}) =>
  axiosService.put(`/api/Organizations?access_token=${token}`, {
    name,
    company,
    country,
    lang,
    isActive,
    id,
  });

export const getOrganizationsList = ({ token, filter, page }) =>
  axiosService.get(`/api/Organizations/`, {
    params: {
      access_token: token,
      filter: {
        include: ['rules', 'users', 'attendees', 'introMessage'],
        ...filter,
        order: 'createdAt DESC',
      },
      ...page,
    },
  });

export const getRules = ({ token }) =>
  axiosService.get(`/api/Rules?access_token=${token}`);

export const addRule = ({ token, orgId, ruleId }) =>
  axiosService.put(
    `/api/Organizations/${orgId}/rules/rel/${ruleId}?access_token=${token}`,
  );

export const removeRule = ({ token, orgId, ruleId }) =>
  axiosService.delete(
    `/api/Organizations/${orgId}/rules/rel/${ruleId}?access_token=${token}`,
  );

export const addUser = ({ token, orgId, userId }) =>
  axiosService.put(
    `/api/Organizations/${orgId}/users/rel/${userId}?access_token=${token}`,
  );

export const removeUser = ({ token, orgId, userId }) =>
  axiosService.delete(
    `/api/Organizations/${orgId}/users/rel/${userId}?access_token=${token}`,
  );

export const getOrganizationsCount = ({ token }) =>
  axiosService.get(`/api/Organizations/count?access_token=${token}`);

export const getAnalysts = ({ token, keyWord }) =>
  axiosService.get(`/api/AppUser/searchByRole?access_token=${token}`, {
    params: {
      roleNames: 'Analyst',
      filter: { email: { like: `%${keyWord}%` } },
    },
  });

export const addDefaultAttendee = ({ token, organizationId, attendee }) =>
  axiosService.post(
    `/api/Organizations/${organizationId}/attendees?access_token=${token}`,
    attendee,
  );

export const updateDefaultAttendee = ({ token, organizationId, attendee }) =>
  axiosService.put(
    `/api/Organizations/${organizationId}/attendees/${attendee.id}?access_token=${token}`,
    attendee,
  );

export const removeAttendee = ({ token, organizationId, attendeeId }) =>
  axiosService.delete(
    `/api/Organizations/${organizationId}/attendees/${attendeeId}?access_token=${token}`,
  );

export const validateOrganization = (organization, rulesList) => {
  const errors = {};

  const titleError = !organization.name.trim() && 'Please specify a title.';
  const { attendees = [], rules = [] } = organization;

  const nameEmpty =
    attendees.some(({ name }) => !name.trim()) &&
    "The person's name should not be empty.";
  const emailError =
    !attendees.every(({ email }) => isValidEmail(email)) &&
    'Please specify a valid email address.';
  const { id: twoAuthRuleId } = rulesList.find(
    ({ code }) => code === 'MULTI_FACTOR_AUTHORIZATION',
  );
  const isTwoFactorAuthRuleEnabled = rules.includes(twoAuthRuleId);
  const notAllNumbersSpecifiedError =
    isTwoFactorAuthRuleEnabled &&
    attendees.some(({ phoneNumber }) => !isValidPhoneNumber(phoneNumber)) &&
    VALIDATION_ERROR_MESSAGES.notAllNumbersAreSpecifiedErrorMessage;

  const errorMessage =
    titleError || nameEmpty || emailError || notAllNumbersSpecifiedError;
  checkErrors({
    errorMessage,
    errors,
  });
};



// WEBPACK FOOTER //
// ./services/organizationsResource.js